// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const MozillaIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <path
      fill="url(#mozilla_svga)"
      d="M22.7 8.06c-.51-1.22-1.54-2.53-2.34-2.94q.86 1.67 1.18 3.53v.02c-1.32-3.28-3.54-4.6-5.37-7.48l-.4-.69a2 2 0 0 1-.18-.48L15.57 0h-.04a8.5 8.5 0 0 0-4 6.46 6 6 0 0 0-3.2 1.24q-.15-.13-.3-.23A5.4 5.4 0 0 1 8 4.63 9 9 0 0 0 5.2 6.8c-.47-.59-.43-2.51-.4-2.92q-.2.09-.4.21-.6.45-1.13.98-.6.6-1.1 1.3A10 10 0 0 0 .63 9.89l-.02.08-.11.73v.02q-.15.8-.2 1.6v.07a11.63 11.63 0 0 0 23.1 1.96l.06-.45c.24-1.98-.02-3.99-.76-5.84m-13.41 9.1.16.09zm12.25-8.5z"
    />
    <path
      fill="url(#mozilla_svgb)"
      d="M22.7 8.06c-.51-1.22-1.54-2.53-2.34-2.95q.86 1.68 1.18 3.53v.03c.9 2.56.76 5.38-.36 7.85a10 10 0 0 1-9.62 5.65C6.11 22 1.3 17.97.4 12.66c-.16-.84 0-1.26.08-1.94a9 9 0 0 0-.18 1.6v.06a11.63 11.63 0 0 0 23.1 1.97l.05-.45c.24-1.98-.02-3.99-.76-5.84"
    />
    <path
      fill="url(#mozilla_svgc)"
      d="M22.7 8.06c-.51-1.22-1.54-2.53-2.34-2.95q.86 1.68 1.18 3.53v.03c.9 2.56.76 5.38-.36 7.85a10 10 0 0 1-9.62 5.65C6.11 22 1.3 17.97.4 12.66c-.16-.84 0-1.26.08-1.94a9 9 0 0 0-.18 1.6v.06a11.63 11.63 0 0 0 23.1 1.97l.05-.45c.24-1.98-.02-3.99-.76-5.84"
    />
    <path
      fill="url(#mozilla_svgd)"
      d="m17.04 9.42.07.06q-.45-.79-1.08-1.41C12.4 4.45 15.08.23 15.53 0a8.5 8.5 0 0 0-4 6.46l.41-.02a5.9 5.9 0 0 1 5.1 2.97"
    />
    <path
      fill="url(#mozilla_svge)"
      d="M11.95 10.15c-.02.29-1.04 1.28-1.4 1.28-3.31 0-3.85 2-3.85 2a4.9 4.9 0 0 0 3.28 4.04q.74.27 1.51.3c5.8.27 6.93-6.94 2.74-9.03.99-.13 1.99.12 2.8.68a5.9 5.9 0 0 0-5.09-2.97q-.2 0-.4.02A6 6 0 0 0 8.32 7.7c.18.15.38.35.8.77.79.77 2.81 1.58 2.82 1.67"
    />
    <path
      fill="url(#mozilla_svgf)"
      d="M11.95 10.15c-.02.29-1.04 1.28-1.4 1.28-3.31 0-3.85 2-3.85 2a4.9 4.9 0 0 0 3.28 4.04q.74.27 1.51.3c5.8.27 6.93-6.94 2.74-9.03.99-.13 1.99.12 2.8.68a5.9 5.9 0 0 0-5.09-2.97q-.2 0-.4.02A6 6 0 0 0 8.32 7.7c.18.15.38.35.8.77.79.77 2.81 1.58 2.82 1.67"
    />
    <path
      fill="url(#mozilla_svgg)"
      d="M7.79 7.32q.14.08.24.16A5.4 5.4 0 0 1 8 4.63 9 9 0 0 0 5.2 6.8c.05 0 1.74-.03 2.59.52"
    />
    <path
      fill="url(#mozilla_svgh)"
      d="M.4 12.66c.9 5.3 5.7 9.36 11.17 9.5a10 10 0 0 0 9.6-5.64 10.5 10.5 0 0 0 .37-7.85v-.02.01c.41 2.7-.96 5.3-3.1 7.08v.01c-4.18 3.4-8.18 2.05-8.98 1.5l-.17-.08C6.85 16 5.85 13.79 6.06 11.88a3 3 0 0 1-2.75-1.73 4.4 4.4 0 0 1 4.27-.17 5.8 5.8 0 0 0 4.37.17c0-.1-2.03-.9-2.82-1.68-.42-.41-.62-.61-.8-.76a4 4 0 0 0-.54-.39c-.85-.55-2.53-.52-2.59-.52-.47-.58-.43-2.51-.4-2.91q-.2.08-.4.2-.6.45-1.13.98A10 10 0 0 0 .62 9.89a9 9 0 0 0-.22 2.77"
    />
    <path
      fill="url(#mozilla_svgi)"
      d="M16.03 8.07q.64.63 1.08 1.4l.18.15c2.63 2.43 1.25 5.87 1.15 6.11 2.14-1.76 3.51-4.37 3.1-7.07-1.32-3.28-3.55-4.6-5.37-7.48l-.4-.69a2 2 0 0 1-.18-.48h-.06c-.45.21-3.11 4.44.5 8.05"
    />
    <path
      fill="url(#mozilla_svgj)"
      d="M17.29 9.62q-.07-.07-.18-.14l-.07-.05a4 4 0 0 0-2.8-.69c4.18 2.1 3.06 9.3-2.74 9.03a5 5 0 0 1-1.86-.43l-.2-.1.01.01c.81.55 4.8 1.9 8.98-1.5v-.02c.11-.24 1.5-3.68-1.14-6.1"
    />
    <path
      fill="url(#mozilla_svgk)"
      d="M6.7 13.43s.54-2 3.85-2c.36 0 1.38-1 1.4-1.28a5.8 5.8 0 0 1-4.37-.18 4.4 4.4 0 0 0-4.28.18 3 3 0 0 0 2.76 1.73c-.22 1.9.79 4.12 3.22 5.28q.08.05.17.08a4.9 4.9 0 0 1-2.74-3.8"
    />
    <path
      fill="url(#mozilla_svgl)"
      d="M22.7 8.06c-.51-1.22-1.54-2.53-2.34-2.94q.86 1.67 1.18 3.53v.02c-1.32-3.28-3.55-4.6-5.37-7.48l-.4-.69a2 2 0 0 1-.18-.48L15.57 0h-.04a8.5 8.5 0 0 0-4 6.46l.41-.02a5.9 5.9 0 0 1 5.1 2.98 4 4 0 0 0-2.8-.68c4.18 2.09 3.06 9.3-2.74 9.02a5 5 0 0 1-1.86-.43l-.2-.1.01.01-.16-.08.16.08a4.9 4.9 0 0 1-2.74-3.8s.53-2.01 3.84-2.01c.36 0 1.38-1 1.4-1.29 0-.1-2.03-.9-2.82-1.68-.42-.41-.62-.61-.8-.76l-.3-.23A5.4 5.4 0 0 1 8 4.64 9 9 0 0 0 5.2 6.8c-.47-.58-.43-2.51-.4-2.91q-.2.08-.4.2-.6.45-1.13.98A10 10 0 0 0 .62 9.9l-.02.07a13.54 13.54 0 0 0-.3 2.36v.06a11.63 11.63 0 0 0 23.1 1.97l.05-.45c.24-1.99-.02-4-.76-5.85"
    />
    <defs>
      <radialGradient
        id="mozilla_svgb"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="translate(20.4 2.7)scale(24.2526)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.13} stopColor="#FFBD4F" />
        <stop offset={0.19} stopColor="#FFAC31" />
        <stop offset={0.25} stopColor="#FF9D17" />
        <stop offset={0.28} stopColor="#FF980E" />
        <stop offset={0.4} stopColor="#FF563B" />
        <stop offset={0.47} stopColor="#FF3750" />
        <stop offset={0.71} stopColor="#F5156C" />
        <stop offset={0.78} stopColor="#EB0878" />
        <stop offset={0.86} stopColor="#E50080" />
      </radialGradient>
      <radialGradient
        id="mozilla_svgc"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="translate(11.4 12.61)scale(24.2526)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.3} stopColor="#960E18" />
        <stop offset={0.35} stopColor="#B11927" stopOpacity={0.74} />
        <stop offset={0.43} stopColor="#DB293D" stopOpacity={0.34} />
        <stop offset={0.5} stopColor="#F5334B" stopOpacity={0.09} />
        <stop offset={0.53} stopColor="#FF3750" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="mozilla_svgd"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="translate(14.4 -2.7)scale(17.5681)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.13} stopColor="#FFF44F" />
        <stop offset={0.25} stopColor="#FFDC3E" />
        <stop offset={0.51} stopColor="#FF9D12" />
        <stop offset={0.53} stopColor="#FF980E" />
      </radialGradient>
      <radialGradient
        id="mozilla_svge"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="translate(8.7 18.91)scale(11.547)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.35} stopColor="#3A8EE6" />
        <stop offset={0.47} stopColor="#5C79F0" />
        <stop offset={0.67} stopColor="#9059FF" />
        <stop offset={1} stopColor="#C139E6" />
      </radialGradient>
      <radialGradient
        id="mozilla_svgf"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(-13.59 50.46 -47.5)scale(6.12321 7.16875)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.21} stopColor="#9059FF" stopOpacity={0} />
        <stop offset={0.28} stopColor="#8C4FF3" stopOpacity={0.06} />
        <stop offset={0.75} stopColor="#7716A8" stopOpacity={0.45} />
        <stop offset={0.97} stopColor="#6E008B" stopOpacity={0.6} />
      </radialGradient>
      <radialGradient
        id="mozilla_svgg"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="translate(11.1 1.8)scale(8.30832)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE226" />
        <stop offset={0.12} stopColor="#FFDB27" />
        <stop offset={0.29} stopColor="#FFC82A" />
        <stop offset={0.5} stopColor="#FFA930" />
        <stop offset={0.73} stopColor="#FF7E37" />
        <stop offset={0.79} stopColor="#FF7139" />
      </radialGradient>
      <radialGradient
        id="mozilla_svgh"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="translate(17.7 -3.6)scale(35.4484)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.11} stopColor="#FFF44F" />
        <stop offset={0.46} stopColor="#FF980E" />
        <stop offset={0.62} stopColor="#FF5634" />
        <stop offset={0.72} stopColor="#FF3647" />
        <stop offset={0.9} stopColor="#E31587" />
      </radialGradient>
      <radialGradient
        id="mozilla_svgi"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(83.98 8.29 7.38)scale(25.9771 17.0486)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF44F" />
        <stop offset={0.06} stopColor="#FFE847" />
        <stop offset={0.17} stopColor="#FFC830" />
        <stop offset={0.3} stopColor="#FF980E" />
        <stop offset={0.36} stopColor="#FF8B16" />
        <stop offset={0.46} stopColor="#FF672A" />
        <stop offset={0.57} stopColor="#FF3647" />
        <stop offset={0.74} stopColor="#E31587" />
      </radialGradient>
      <radialGradient
        id="mozilla_svgj"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="translate(11.1 4.8)scale(22.1275)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.14} stopColor="#FFF44F" />
        <stop offset={0.48} stopColor="#FF980E" />
        <stop offset={0.59} stopColor="#FF5634" />
        <stop offset={0.66} stopColor="#FF3647" />
        <stop offset={0.9} stopColor="#E31587" />
      </radialGradient>
      <radialGradient
        id="mozilla_svgk"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="translate(16.8 6)scale(24.2196)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.09} stopColor="#FFF44F" />
        <stop offset={0.23} stopColor="#FFE141" />
        <stop offset={0.51} stopColor="#FFAF1E" />
        <stop offset={0.63} stopColor="#FF980E" />
      </radialGradient>
      <linearGradient
        id="mozilla_svga"
        x1={21.15}
        x2={1.84}
        y1={3.73}
        y2={22.36}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.05} stopColor="#FFF44F" />
        <stop offset={0.11} stopColor="#FFE847" />
        <stop offset={0.23} stopColor="#FFC830" />
        <stop offset={0.37} stopColor="#FF980E" />
        <stop offset={0.4} stopColor="#FF8B16" />
        <stop offset={0.46} stopColor="#FF672A" />
        <stop offset={0.53} stopColor="#FF3647" />
        <stop offset={0.7} stopColor="#E31587" />
      </linearGradient>
      <linearGradient
        id="mozilla_svgl"
        x1={20.92}
        x2={4.49}
        y1={3.63}
        y2={20.06}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.17} stopColor="#FFF44F" stopOpacity={0.8} />
        <stop offset={0.27} stopColor="#FFF44F" stopOpacity={0.63} />
        <stop offset={0.49} stopColor="#FFF44F" stopOpacity={0.22} />
        <stop offset={0.6} stopColor="#FFF44F" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>,
  "Mozilla",
);
export default MozillaIcon;
